export { default as CircularProgress, CircularProgressProps } from '@material-ui/core/CircularProgress'
